import { Component, OnInit } from '@angular/core';
import { FEATURE_FORMS } from './forms';
import { BaseComponentConfig, ComponentConfig, ConfigOptions, UpdateComponentStoreService, ViewContainersService, getColumnFieldTitles, getFields, getIdFieldName, getTarget, getTargets, getTitleDescriptionField } from '@urbannex/view-containers';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { baseMenuItems, configOptions } from './configoptions';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ngx-feature',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./feature.component.scss']
})
export class FeatureComponent extends BaseComponentConfig implements OnInit {

  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    private http:HttpClient,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(configOptions);
   }

  ngOnInit(): void {
    this.baseUrl = this.getBaseUrl();
    let menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    let menuTag = menuAndTitleOptions.menuTag;
    let menuItems:NbMenuItem[] = [];
    baseMenuItems.forEach(item => {
      menuItems.push(item);
    });
    this.menuService.addItems(menuItems,menuTag)
  }
  
}
